import moment from "moment";
import { useState } from "react";

const Message = ({ message, isRead, time,  readStatusHandler, timeFormat }) => {
    const expandHandler = () => {
        setExpanded(prev => !prev);
        if (isRead=== false) {
            readStatusHandler()
        }
    }
    if (isRead === false && message?.length <= 80) {
        readStatusHandler()
    }
    const [expanded, setExpanded] = useState(false);
    const displayText =
        expanded || message?.length <= 80
            ? message
            : message?.slice(0, 80)+'...';
    return (
        <div onClick={() => expandHandler()} style={{ cursor: 'pointer' }}>
            <div style={{ backgroundColor: isRead === false ? ' #EDEDE3' : "#FFFFFF", padding: '16px 8px' }}>
                <span
                    style={{
                        fontFamily: "Inter",
                        fontSize: "12px",
                        lineHeight: "22px",
                        fontWeight: 400,
                        letterSpacing: "-0.4px",
                        color: '#85897E'
                    }}
                >
                {moment(time, timeFormat).format("DD MMM YYYY, h:mm A")}
                </span>
                <p
                    style={{
                        fontFamily: "Inter",
                        fontSize: "12px",
                        lineHeight: "16px",
                        fontWeight: 400,
                        letterSpacing: "-0.4px",
                    }}
                >
                    {displayText}
                </p>
            </div>
            <div style={{ border: '1px solid #D8DADE' }}></div>
        </div>
    );
};

export default Message;
